import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _client, _currentResult, _currentMutation, _mutateOptions, _updateResult, _notify;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/mutationObserver.ts
import { getDefaultState } from "./mutation.js";
import { notifyManager } from "./notifyManager.js";
import { Subscribable } from "./subscribable.js";
import { hashKey, shallowEqualObjects } from "./utils.js";
var MutationObserver = (_client = /*#__PURE__*/new WeakMap(), _currentResult = /*#__PURE__*/new WeakMap(), _currentMutation = /*#__PURE__*/new WeakMap(), _mutateOptions = /*#__PURE__*/new WeakMap(), _updateResult = /*#__PURE__*/new WeakSet(), _notify = /*#__PURE__*/new WeakSet(), class MutationObserver extends Subscribable {
  constructor(client, options) {
    super();
    _classPrivateMethodInitSpec(this, _notify);
    _classPrivateMethodInitSpec(this, _updateResult);
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentResult, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentMutation, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _mutateOptions, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _client, client);
    this.setOptions(options);
    this.bindMethods();
    _classPrivateMethodGet(this, _updateResult, _updateResult2).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }
  setOptions(options) {
    var _classPrivateFieldGet2;
    const prevOptions = this.options;
    this.options = _classPrivateFieldGet(this, _client).defaultMutationOptions(options);
    if (!shallowEqualObjects(this.options, prevOptions)) {
      _classPrivateFieldGet(this, _client).getMutationCache().notify({
        type: "observerOptionsUpdated",
        mutation: _classPrivateFieldGet(this, _currentMutation),
        observer: this
      });
    }
    if (prevOptions !== null && prevOptions !== void 0 && prevOptions.mutationKey && this.options.mutationKey && hashKey(prevOptions.mutationKey) !== hashKey(this.options.mutationKey)) {
      this.reset();
    } else if (((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _currentMutation)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.state.status) === "pending") {
      _classPrivateFieldGet(this, _currentMutation).setOptions(this.options);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldGet3;
      (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _currentMutation)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeObserver(this);
    }
  }
  onMutationUpdate(action) {
    _classPrivateMethodGet(this, _updateResult, _updateResult2).call(this);
    _classPrivateMethodGet(this, _notify, _notify2).call(this, action);
  }
  getCurrentResult() {
    return _classPrivateFieldGet(this, _currentResult);
  }
  reset() {
    var _classPrivateFieldGet4;
    (_classPrivateFieldGet4 = _classPrivateFieldGet(this, _currentMutation)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.removeObserver(this);
    _classPrivateFieldSet(this, _currentMutation, void 0);
    _classPrivateMethodGet(this, _updateResult, _updateResult2).call(this);
    _classPrivateMethodGet(this, _notify, _notify2).call(this);
  }
  mutate(variables, options) {
    var _classPrivateFieldGet5;
    _classPrivateFieldSet(this, _mutateOptions, options);
    (_classPrivateFieldGet5 = _classPrivateFieldGet(this, _currentMutation)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.removeObserver(this);
    _classPrivateFieldSet(this, _currentMutation, _classPrivateFieldGet(this, _client).getMutationCache().build(_classPrivateFieldGet(this, _client), this.options));
    _classPrivateFieldGet(this, _currentMutation).addObserver(this);
    return _classPrivateFieldGet(this, _currentMutation).execute(variables);
  }
});
function _updateResult2() {
  var _classPrivateFieldGet6, _classPrivateFieldGet7;
  const state = (_classPrivateFieldGet6 = (_classPrivateFieldGet7 = _classPrivateFieldGet(this, _currentMutation)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.state) !== null && _classPrivateFieldGet6 !== void 0 ? _classPrivateFieldGet6 : getDefaultState();
  _classPrivateFieldSet(this, _currentResult, _objectSpread(_objectSpread({}, state), {}, {
    isPending: state.status === "pending",
    isSuccess: state.status === "success",
    isError: state.status === "error",
    isIdle: state.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  }));
}
function _notify2(action) {
  notifyManager.batch(() => {
    if (_classPrivateFieldGet(this, _mutateOptions) && this.hasListeners()) {
      const variables = _classPrivateFieldGet(this, _currentResult).variables;
      const context = _classPrivateFieldGet(this, _currentResult).context;
      if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
        var _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10, _classPrivateFieldGet11;
        (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(this, _mutateOptions)).onSuccess) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.call(_classPrivateFieldGet9, action.data, variables, context);
        (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = _classPrivateFieldGet(this, _mutateOptions)).onSettled) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(_classPrivateFieldGet11, action.data, null, variables, context);
      } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
        var _classPrivateFieldGet12, _classPrivateFieldGet13, _classPrivateFieldGet14, _classPrivateFieldGet15;
        (_classPrivateFieldGet12 = (_classPrivateFieldGet13 = _classPrivateFieldGet(this, _mutateOptions)).onError) === null || _classPrivateFieldGet12 === void 0 || _classPrivateFieldGet12.call(_classPrivateFieldGet13, action.error, variables, context);
        (_classPrivateFieldGet14 = (_classPrivateFieldGet15 = _classPrivateFieldGet(this, _mutateOptions)).onSettled) === null || _classPrivateFieldGet14 === void 0 || _classPrivateFieldGet14.call(_classPrivateFieldGet15, void 0, action.error, variables, context);
      }
    }
    this.listeners.forEach(listener => {
      listener(_classPrivateFieldGet(this, _currentResult));
    });
  });
}
export { MutationObserver };